import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Box, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  ActiveTab,
  TabsContainer,
} from '../../LearninghubExplore/Filteration/FilterationTags/style';

const CourseFilteration = (props) => {
  const classes = useStyle();

  const router: any = useRouter();

  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const tagsHandler = (cohort) => {
    if (router.isReady) {
      router.push({ query: { ...router.query, cohort: `${cohort}` } });
    }
  };

  const allTags = ['All', 'Rhino and Grasshopper', 'BIM Professional'];

  useEffect(() => {
    setValue(
      allTags.indexOf(router.query.cohort ? router.query.cohort : 'All'),
    );
  }, [router.query, allTags]);

  return (
    <Box
      bgcolor="lightgrey"
      py={2}
      overflow="auto"
      position="sticky"
      top="56"
      className={classes.stickyContainer}
    >
      <Container>
        <div>
          <TabsContainer
            value={value}
            iscommunity={'true'}
            onChange={handleChange}
            orientation="horizontal"
            variant="scrollable"
          >
            {allTags.map((cohort, key) => (
              <ActiveTab
                onClick={() => tagsHandler(cohort)}
                className={`${classes.tab} ${classes.btnComunity}`}
                label={cohort}
                key={key}
              />
            ))}
          </TabsContainer>
        </div>
      </Container>
    </Box>
  );
};

const useStyle = makeStyles((theme: any) => ({
  stickyContainer: {
    position: 'sticky',
    top: 64,
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      top: 72,
    },
  },
  tab: {
    zIndex: 2,
  },
  btnComunity: {
    border: '1px solid grey',
    borderRadius: '45px',
    marginRight: theme.spacing(2),
  },
  active: {
    background: theme.palette.tertiary.black,
    color: theme.palette.tertiary.white,
  },
}));

export default CourseFilteration;
